import { useMsal } from "@azure/msal-react";
import { Spinner } from "@chakra-ui/react";
import { useEffect } from "react";

export default function AuthLoader() {
  const { instance } = useMsal();

  useEffect(() => {
    const handleAuthentication = async () => {
      try {
        const activeAccount = instance.getActiveAccount();
        if (!activeAccount) {
          const authResult = await instance.handleRedirectPromise();
          const account = instance.getActiveAccount();
          if (!account) {
            await instance.loginRedirect({
              scopes: ["openid", "offline_access"],
            });
          }
        }
      } catch (e: any) {
        await instance.loginRedirect({
          scopes: ["openid", "offline_access"],
        });
      };
    }

    handleAuthentication();

  }, [instance]);

  return <Spinner style={{ position: 'fixed', top: '50%', left: '50%' }} size="lg" color="red" />;
}
